import { InjectionToken } from '@angular/core';

export { IResourceContext, ResourceContextType, ROOT_RESOURCE_CONTEXT_DATA } from 'shell-models-lib';

export const RESOURCE_CONTEXT_DATA = 'RESOURCE_CONTEXT_DATA';
export const RESOURCE_CONTEXT_DATA_TOKEN = new InjectionToken(RESOURCE_CONTEXT_DATA);
